$(document).ready(function () {

    // collection page filter price range code start
    const minPriceEl = $("#minProdVal");
    const maxPriceEl = $("#maxProdVal");
    if(minPriceEl.length && maxPriceEl.length){
      var minCollectionPrice = $("#minProdVal").val();
      var maxCollectionPrice = $("#maxProdVal").val();
      
      const maxCollectionPriceInArray = $("#maxProdVal").val();
      const valuesForSlider = [];
      for (let i = 1; i <= maxCollectionPriceInArray; i++) {
        valuesForSlider.push(i);
      }
      console.log(valuesForSlider);
      
      var rangeSlider = document.getElementById("priceRangeSlider");
      var moneyFormat = wNumb({
        decimals: 0,
        thousand: ",",
        prefix: "$",
      });
    
      noUiSlider.create(rangeSlider, {
        start: [minCollectionPrice, maxCollectionPrice],
        step: 1,
        range: { min: 0, max: valuesForSlider.length },
        format: moneyFormat,
        connect: true,
      });
    
      rangeSlider.noUiSlider.on("update", function (values, handle) {
        document.getElementById("slider-value-min").innerHTML = values[0];
        document.getElementById("slider-value-max").innerHTML = values[1];
    
        $("#minProdVal").val(moneyFormat.from(values[0]));
        $("#maxProdVal").val(moneyFormat.from(values[1]));
    
        console.log(moneyFormat.from(values[0]));
        console.log(moneyFormat.from(values[1]));
      });
    }
    // collection page filter price range code end
      
  });
  
//   $('#mobile_sidebar_button .filter_drawer_button').click(function(){
//       $('aside.sidebar-section.column').addClass('active_sidebar');
//   });
  
//   $('.filter_close_icon').click(function(){
//       $('aside.sidebar-section.column').removeClass('active_sidebar');
//   });